/* global $ */

'use strict';

function Navigation(nikeFooterLang, nikeFooterCountry) {
	window.NIKE = window.NIKE || {};
	window.NIKE.isMobile = window.NIKE.isMobile || ( window.innerWidth < 769 );

	var lang = nikeFooterLang || 'en_gb';
	var country = nikeFooterCountry || 'gb';
	var urlLocalePart =  country + '/' + lang;

	window.nsgConfig = {
		HOST: '//www.nike.com',
		BASEPATH: '/styleguide/nsg/',
		TENANT: 'NIKE',
		LOCALE: lang,
		PLATFORM: window.NIKE.isMobile ? 'mobile' : 'desktop',
		PLACEMENT: 'append'
	};

	(function() {
		var scriptNavigation = document.createElement('script');
		var scriptStyleguide = document.createElement('script');
		var scriptEl = document.getElementsByTagName('script')[0];
		// load header/footer
		scriptNavigation.src = '//m.nike.com/' + urlLocalePart + '/NikeScriptManager.js?app=nikestore&version=latest&assets=nike,nike.gadget.mobile.OneNikeFooter,nike.gadget.mobile.OneNikeNav&assetType=SCRIPT';
		// Load Style guide
		scriptStyleguide.src = '//www.nike.com/styleguide/init/nsg.js';

		scriptNavigation.async = 'true';
		scriptStyleguide.async = 'true';

		if (!window.NIKE.isMobile) {
			var isSecure = document.location.protocol === 'https:' ? 'secure-' : '';
			document.getElementById('nikeheader').setAttribute('data-gadget', 'nike.gadget.OneNikeNav');
			document.getElementById('nikefooter').setAttribute('data-gadget', 'nike.gadget.OneNikeFooter');
			scriptNavigation.src = '//' + isSecure + 'store.nike.com/' + urlLocalePart + '/NikeScriptManager.js?app=nikestore&version=latest&assets=nike,nike.gadget.OneNikeFooter,nike.gadget.OneNikeNav&assetType=SCRIPT';
		}

		scriptEl.parentNode.insertBefore(scriptStyleguide, scriptEl);
		scriptEl.parentNode.insertBefore(scriptNavigation, scriptEl);

		$('header').on('click', 'a', function(e){
			if ( $(e.currentTarget).attr('href') === '#' ) {
				e.preventDefault();
			}
		});
	})();
}

module.exports = Navigation;
